import React from 'react';
import { getRiskLevel } from '../../utils/securityLogic';

const LABELS = ['Identity\n& Access', 'Endpoint\n& Network', 'Backup\n& Recovery', 'Email\n& Phishing', 'Awareness\n& Policy', 'Compliance\n& Insurance'];

const RadarChart = ({ domains }) => {
  const cx = 130, cy = 130, r = 90;
  const n = 6;
  const angleStep = (2 * Math.PI) / n;
  const getPoint = (angle, radius) => ({
    x: cx + radius * Math.cos(angle - Math.PI / 2),
    y: cy + radius * Math.sin(angle - Math.PI / 2),
  });

  const rings = [1, 2, 3, 4, 5];
  const dataPoints = domains.map((d, i) => getPoint(i * angleStep, (d.score / 5) * r));
  const dataPath = dataPoints.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x},${p.y}`).join(' ') + 'Z';

  const avgScore = domains.reduce((a, b) => a + b.score, 0) / domains.length;
  // Use VEIT Secondary Blue for LOW/Good instead of generic blue
  const color = { CRITICAL: '#dc2626', HIGH: '#ea580c', MEDIUM: '#ca8a04', LOW: '#2F6FED', MINIMAL: '#16a34a' }[getRiskLevel(avgScore).label] || '#2F6FED';

  return (
    <div className="bg-white border border-veit-border rounded-xl p-5 shadow-sm">
      <div className="text-[10px] font-bold text-veit-gray uppercase tracking-widest mb-3">Security Radar</div>
      <svg viewBox="0 0 260 260" className="w-full max-w-[260px] mx-auto">
        {/* Grid rings */}
        {rings.map(ring => {
          const pts = Array.from({ length: n }, (_, i) => getPoint(i * angleStep, (ring / 5) * r));
          const path = pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x},${p.y}`).join(' ') + 'Z';
          return <path key={ring} d={path} fill="none" stroke="#D1D5DB" strokeWidth={ring === 5 ? 1.5 : 0.8} />;
        })}
        {/* Axis lines */}
        {Array.from({ length: n }, (_, i) => {
          const pt = getPoint(i * angleStep, r);
          return <line key={i} x1={cx} y1={cy} x2={pt.x} y2={pt.y} stroke="#D1D5DB" strokeWidth="0.8" />;
        })}
        {/* Data area */}
        <path d={dataPath} fill={color} fillOpacity="0.15" stroke={color} strokeWidth="2" strokeLinejoin="round" />
        {/* Data points */}
        {dataPoints.map((p, i) => (
          <circle key={i} cx={p.x} cy={p.y} r="4" fill={color} stroke="white" strokeWidth="1.5" />
        ))}
        {/* Labels */}
        {Array.from({ length: n }, (_, i) => {
          const pt = getPoint(i * angleStep, r + 22);
          const lines = LABELS[i].split('\n');
          return (
            <text key={i} x={pt.x} y={pt.y} textAnchor="middle" dominantBaseline="middle"
              fontSize="7.5" fontWeight="600" fill="#414042">
              {lines.map((line, li) => (
                <tspan key={li} x={pt.x} dy={li === 0 ? (lines.length > 1 ? '-0.5em' : '0') : '1.2em'}>{line}</tspan>
              ))}
            </text>
          );
        })}
        {/* Score labels on axes */}
        {[1, 3, 5].map(v => {
          const pt = getPoint(0, (v / 5) * r);
          return (
            <text key={v} x={pt.x + 3} y={pt.y} fontSize="6" fill="#9ca3af" dominantBaseline="middle">{v}</text>
          );
        })}
      </svg>
    </div>
  );
};

export default RadarChart;